<template>
    <div id="login">
        <div class="row">
            <div class="col-md-4">
            </div>
            <div class="col-md-4 well">
            </div>
            <div class="col-md-4">
            </div>
        </div>
    </div>
</template>

<script>
import { axios } from "../main";

export default {
  name: "logout",
  computed: {
    token(){
        return this.$store.state.userStore.token
    },
    domain() {
      return this.$store.state.userStore.domain;
    }
  },
  methods: {
        jumpToCF(logoutURL){
          // ie 11 persistiert sehr merkwürdig? 
          
          let test =localStorage.getItem('vuex')
          if(!test) {
            document.location.href = logoutURL
          }
          else{
            //localStorage.removeItem('vuex')
            localStorage.clear();
            sessionStorage.clear();
           
            window.setTimeout(this.jumpToCF(logoutURL),500);
          }
        }

  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      var masterDomain = this.token.masterDomain
      var modules = this.domain.modules
      //await self.$store.dispatch("setAnalysenReset")
      await self.$store.dispatch("logout");
      localStorage.clear();
      sessionStorage.clear();
      axios.defaults.headers.common["Authorization"] = "--- void ---"; //entfernt axios jwt

      //if (masterDomain > 1000) {
      if (modules === "ZVM") {
        // Verwerter
        window.close();
        //document.location.href = "/vis/index.cfm?Nav=510";
      } else if (masterDomain > 0) {
        // TSM oder Zusatzmodulkunde
        //ie11 braucht etwas zeit um zu persistieren ..
        self.jumpToCF("/dbp/index.cfm?Nav=280&Action=changeDomain&ActionParams=ID&ActionValues=" + masterDomain)
      } else {
        // Produzent
       self.jumpToCF("/dbp/index.cfm?Nav=9")
      }
    });
    
  },
  mounted() {
    // after DOM rendering is done ..
  }
};
</script>